import { QueryKey, MutationKey } from '@tanstack/react-query';

export const webEventsQueryKeys: QueryKey = ['corp', 'webEvents', 'query'];
export const webEventGetKeys: unknown[] = ['admin', 'webEvent', 'get'];

export const createWebEventMutationKey: MutationKey = ['corp', 'webEvent', 'create'];
export const updateWebEventMutationKey: MutationKey = ['corp', 'webEvent', 'update'];
export const deleteWebEventMutationKey: MutationKey = ['corp', 'webEvent', 'delete'];
